import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      // Token-backed typography classes — treated as a single group so
      // they merge with each other, but NOT with text-color utilities.
      'font-size': [
        {
          text: [
            'heading-3xl',
            'heading-2xl',
            'heading-xl',
            'heading-lg',
            'heading-md',
            'heading-sm',
            'heading-xs',
            'subheading',
            'subheading-sm',
            'paragraph-lg',
            'paragraph',
            'paragraph-xs',
            'caption',
            'overline',
          ],
        },
      ],
    },
  },
});

/**
 * Merge Tailwind classes without conflicts.
 * Understands our token-backed typography classes (nw-typography-paragraph-lg, etc.)
 * so they aren't incorrectly stripped by tailwind-merge's text-color logic.
 */
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
